module.exports = __webpack_public_path__ + "media/video303.d17ef7e8.mp4";